
import { Component, Vue, Prop } from "vue-property-decorator";
import { IPlot } from "@/models/Plots";

@Component
export default class PlotWidget extends Vue {
  @Prop({ type: Object, required: true })
  protected data!: IPlot;
}
